import { Icon } from 'roo-ui/components';

const ClassicIcon = (props) => <Icon name="ribbon" size={18} color="grey.charcoal" title="Qantas Classic Hotel Reward" {...props} />;

export default ClassicIcon;
